/**
 * 计划管理接口
 */
export default {
  // 需求计划列表查询api
  plan_demandPlanningQryList: {
    // mock: true,
    control: 'dyc/plan/demandPlanningQryList'
  },
  // 链上U谷应用需求计划创建API
  plan_addDemanPlan: {
    // mock:true,
    control: 'dyc/plan/demandPlanningToCreate'
  },
  // 链上U谷应用计划临时ID生成API
  plan_creatPlanTmpId: {
    // mock: true,
    control: 'dyc/plan/creatPlanTmpId'
  },
  // 公用应用-商品中心物料搜索API
  plan_dealDycUccThematerialsearch: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccThematerialsearch'
  },
  // 公用应用-商品中心物料分类查询API
  plan_getDycUccThematerialclassificationQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccThematerialclassificationQry'
  },
  // 链上U谷应用需求计划删除API
  plan_deleteDemandPlan: {
    // mock: true,
    control: 'dyc/plan/deleteDemandPlan'
  },
  // 链上U谷应用需求计划详情查询API
  plan_demandPlanDetailsQry: {
    // mock: true,
    control: 'dyc/plan/demandPlanDetailsQry'
  },
  // 链上U谷应用需求计划撤回API
  plan_demandPlanToWithDraw: {
    // mock: true,
    control: 'dyc/plan/demandPlanToWithDraw'
  },
  // 链上U谷应用需求计划提交API
  plan_demandPlanSubmit: {
    // mock: true,
    control: 'dyc/plan/demandPlanSubmit'
  },
  // 链上U谷应用需求计划明细新增API
  plan_demandPlanItemAdd: {
    // mock: true,
    control: 'dyc/plan/demandPlanItemAdd'
  },
  // 链上U谷应用需求计划明细列表查询API
  plan_demandPlanItemListQry: {
    // mock: true,
    control: 'dyc/plan/demandPlanItemListQry'
  },
  // 链上U谷应用需求计划明细修改API
  plan_demandPlanItemMod: {
    // mock: true,
    control: 'dyc/plan/demandPlanItemMod'
  },
  // 链上U谷应用需求计划明细删除API
  plan_demandPlanItemDel: {
    // mock: true,
    control: 'dyc/plan/demandPlanItemDel'
  },
  // 链上U谷应用需求计划修改API
  plan_demandplanMod: {
    // mock: true,
    control: 'dyc/plan/demandplanMod'
  },
  // 链上U谷应用需求计划汇总列表查询API
  plan_demandPlanSummaryQryList: {
    // mock: true,
    control: 'dyc/plan/demandPlanSummaryQryList'
  },
  // 链上U谷应用需求计划退回API
  plan_demandPlanBack: {
    // mock: true,
    control: 'dyc/plan/demandPlanBack'
  },
  // 链上U谷应用需求计划汇总API
  plan_demandPlanSummary: {
    // mock: true,
    control: 'dyc/plan/demandPlanSummary'
  },
  // 链上U谷应用需求计划明细合并API
  plan_demandPlanMerge: {
    // mock: true,
    control: 'dyc/plan/demandPlanMerge'
  },
  // 链上U谷应用需求计划明细合并取消API
  plan_demandPlanCancelMerge: {
    // mock: true,
    control: 'dyc/plan/demandPlanCancelMerge'
  },
  // 链上U谷应用需求计划明细平衡利库API
  plan_balanceLibrary: {
    // mock: true,
    control: 'dyc/plan/balanceLibrary'
  },
  // 链上U谷应用需求计划汇总提交API
  plan_demandPlanSummarySubmit: {
    // mock:true,
    control: 'dyc/plan/demandPlanSummarySubmit'
  },
  // 计划分配规则配置列表查询API
  plan_listPpcPlanDistributionRule: {
    // mock: true,
    control: 'dyc/plan/listPpcPlanDistributionRule'
  },
  // 计划分配规则配置新增API
  plan_addPlanDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/addPlanDistributionRuleDetail'
  },
  // 计划分配规则配置修改API
  plan_updatePlanDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/updatePlanDistributionRuleDetail'
  },
  // 计划分配规则配置删除API
  plan_deletePlanDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/deletePlanDistributionRuleDetail'
  },
  // 计划分配规则配置详情查询API
  plan_selectPlanDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/selectPlanDistributionRuleDetail'
  },
  // 采购单位与运营机构映射表列表查询
  plan_listPlanWorkflowConfig: {
    // mock: true,
    control: 'dyc/plan/listPlanWorkflowConfig'
  },
  // 采购单位与运营机构映射表删除
  plan_deletePlanWorkflowConfigDetail: {
    // mock: true,
    control: 'dyc/plan/deletePlanWorkflowConfigDetail'
  },
  // 计划分配设置角色查询
  plan_alreadyUsers: {
    // mock: true,
    control: 'dyc/saas/common/user/getAlreadyUsers'
  },
  // 角色列表查询API
  plan_selectRoles: {
    // mock: true,
    control: 'dyc/saas/common/role/getroleInfoList'
  },
  // 迪彩采购计划-应用层-计划快速分配配置列表查询API
  plan_listQuickDistributionRule: {
    // mock: true,
    control: 'dyc/plan/listQuickDistributionRule'
  },
  // 迪彩采购计划-应用层-计划快速分配配置删除API
  plan_deleteQuickDistributionRuleDetailDetele: {
    // mock: true,
    control: 'dyc/plan/deleteQuickDistributionRuleDetailDetele'
  },
  // 迪彩采购计划-应用层-计划快速分配配置新增API
  plan_addQuickDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/addQuickDistributionRuleDetail'
  },
  // 迪彩采购计划-应用层-计划快速分配配置详情查询API
  plan_selectQuickDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/selectQuickDistributionRuleDetail'
  },
  // 迪彩采购计划-应用层-计划快速分配配置修改API
  plan_updateQuickDistributionRuleDetail: {
    // mock: true,
    control: 'dyc/plan/updateQuickDistributionRuleDetail'
  },
  // 迪彩采购计划-应用层-计划流转配置新增API
  plan_addPlanWorkflowConfigDetail: {
    // mock: true,
    control: 'dyc/plan/addPlanWorkflowConfigDetail'
  },
  // 迪彩采购计划-应用层-计划流转配置详情查询API
  plan_selectPlanWorkflowConfigDetail: {
    // mock: true,
    control: 'dyc/plan/selectPlanWorkflowConfigDetail'
  },
  // 迪彩采购计划-应用层-计划流转配置修改API
  plan_updatePlanWorkflowConfigDetail: {
    // mock: true,
    control: 'dyc/plan/updatePlanWorkflowConfigDetail'
  },
  // 迪彩采购计划-应用层-机构计划映射列表查询API
  plan_selectPlanOrgConfigList: {
    // mock: true,
    control: 'dyc/plan/selectPlanOrgConfigList'
  },
  // 迪彩采购计划-应用层-机构计划映射表删除API
  plan_deletePlanOrgConfig: {
    // mock: true,
    control: 'dyc/plan/deletePlanOrgConfig'
  },
  // 迪彩采购计划-应用层-机构计划映射表新增API
  plan_addPlanOrgConfig: {
    // mock: true,
    control: 'dyc/plan/addPlanOrgConfig'
  },
  // 迪彩采购计划-应用层-机构计划映射表详情API
  plan_selectPlanOrgConfig: {
    // mock: true,
    control: 'dyc/plan/selectPlanOrgConfig'
  },
  // 迪彩采购计划-应用层-机构计划映射表修改API
  plan_updatePlanOrgConfig: {
    // mock: true,
    control: 'dyc/plan/updatePlanOrgConfig'
  },
  // 公用应用-应用模式配置列表API
  plan_qryAppModeConfigListPage: {
    // mock: true,
    control: 'dyc/config/cfc/qryAppModeConfigListPage'
  },
  // 公用应用-应用模式配置新增API
  plan_addAppModeConfig: {
    // mock: true,
    control: 'dyc/config/cfc/addAppModeConfig'
  },
  // 公用应用-应用模式配置维护API
  plan_dealAppModeConfig: {
    // mock: true,
    control: 'dyc/config/cfc/dealAppModeConfig'
  },
  // 公用应用-应用模式配置详情API
  plan_qryAppModeConfigDetail: {
    // mock: true,
    control: 'dyc/config/cfc/qryAppModeConfigDetail'
  },
  // 迪彩采购计划-应用层-采购计划列表查询API1
  plan_qryPpcPurchasePlanList: {
    // mock: true,
    control: 'dyc/saas/common/plan/qryPpcPurchasePlanList'
  },
  // 迪彩采购计划-应用层-采购计划明细列表查询API
  plan_qryPpcPurchasePlanItemList: {
    // mock: true,
    control: 'dyc/saas/common/plan/qryPpcPurchasePlanItemList'
  },
  // 迪彩采购计划-应用层-采购计划明细新增API
  plan_dealPpcPurchasePlanItemAdd: {
    // mock: true,
    control: 'dyc/saas/common/plan/dealPpcPurchasePlanItemAdd'
  },
  // 迪彩采购计划-应用层-采购计划删除API
  plan_dealPpcPurchasePlanDel: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanDel'
  },
  // 迪彩采购计划-应用层-采购计划创建API
  plan_dealPpcPurchasePlanToCreat: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanToCreat'
  },
  // 迪彩采购计划-应用层-采购计划修改API
  plan_dealPpcPurchasePlanUpdate: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanUpdate'
  },
  // 迪彩采购计划-应用层-采购计划执行关闭API
  plan_dealPpcPurchasePlanPerformClosed: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanPerformClosed'
  },
  // 迪彩采购计划-应用层-采购计划详情查询API
  plan_getPpcPurchasePlanDetailsQry: {
    // mock: true,
    control: 'dyc/plan/getPpcPurchasePlanDetailsQry'
  },
  // 迪彩采购计划-协议流程信息查询
  dyc_getPpcTransferinformationQry: {
    // mock: true,
    control: 'dyc/plan/getPpcTransferinformationQry'
  },
  // 公用应用-计量单位列表API
  plan_qryMeasureListPage: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/getmeasureInfo'
  },
  // 公用应用-计量单位新增API
  plan_addMeasure: {
    // mock: true,
    control: '/dyc/config/cfc/addMeasure'
  },
  // 公用应用-计量单位修改API
  plan_updateMeasure: {
    // mock: true,
    control: 'dyc/config/cfc/updateMeasure'
  },
  // 公用应用-计量单位维护API
  plan_dealMeasure: {
    // mock: true,
    control: 'dyc/config/cfc/dealMeasure'
  },
  // 链上U谷应用需求计划生成采购计划明细API
  plan_dpcPlanItemAddByDemand: {
    // mock: true,
    control: 'dyc/plan/dpcPlanItemAddByDemand'
  },
  // 迪彩采购计划-应用层-采购计划明细删除API
  plan_dealPpcPurchasePlanItemDel: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanItemDel'
  },
  // 迪彩采购计划-应用层-采购计划明细修改API
  plan_dealPpcPurchasePlanItemUpdate: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanItemUpdate'
  },
  // 迪彩采购计划-应用层-采购计划审批API
  plan_dealPpcPurchasePlanTheExaminationAndApproval: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanTheExaminationAndApproval'
  },
  // 迪彩采购计划-应用层-采购计划一级分配API
  plan_dealPpcPurchasePlanDistributionSelfFirst: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanDistributionSelfFirst'
  },
  // 迪彩采购计划-应用层-采购计划撤回API
  plan_dealPpcPurchasePlanToWithDraw: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanToWithDraw'
  },
  // 链上U谷采购计划应用层—二级分配
  plan_dealPpcPurchasePlanDistributionSelfSecond: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanDistributionSelfSecond'
  },
  // 链上U谷采购计划应用层—匹配商品
  plan_getSkuOrdersearchList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuOrdersearchList'
  },
  // 链上U谷采购计划应用层—加入购物车
  plan_addShoppingCart: {
    // mock: true,
    control: 'dyc/saas/common/user/addShoppingCart'
  },
  // 链上U谷采购计划应用层—加入购物车
  dyc_dealPpcPurchasePlanPerformpurchased: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanPerformpurchased'
  },
  // 链上U谷采购计划应用层—获取地址
  plan_queryReceiveAddress: {
    // mock: true,
    control: 'dyc/saas/common/getLogisticsRelaPage'
  },
  //  分配人员-下拉框
  plan_selectListDistributionItem: {
    // mock: true,
    control: 'dyc/plan/selectListDistributionItem'
  },
  // 快捷分配-人员下拉列表
  plan_selectListPeople: {
    // mock: true,
    control: 'dyc/plan/selectListPeople'
  },
  // 链上U谷采购计划快捷分配
  plan_quicklyDistrbution: {
    // mock: true,
    control: 'dyc/plan/quicklyDistrbution'
  },
  // 链上U谷采购计划执行
  plan_purchasePlanExecute: {
    // mock: true,
    control: 'dyc/plan/purchasePlanExecute'
  },
  // 迪彩采购计划-应用层-采购计划执行完结API
  plan_dealPpcPurchasePlanCompletionOfExecution: {
    // mock: true,
    control: 'dyc/plan/dealPpcPurchasePlanCompletionOfExecution'
  },
  // 公用应用-计划提报时间规则列表API
  plan_qryPresentListPage: {
    // mock: true,
    control: 'dyc/config/cfc/qryPresentListPage'
  },
  // 公用应用-计划提报时间规则维护API
  plan_dealPresent: {
    // mock: true,
    control: 'dyc/config/cfc/dealPresent'
  },
  // 公用应用-计划提报时间规则新增API
  plan_addPresent: {
    // mock: true,
    control: 'dyc/config/cfc/addPresent'
  },
  // 公用应用-计划提报时间规则修改API
  plan_updatePresent: {
    // mock: true,
    control: 'dyc/config/cfc/updatePresent'
  },
  // 公用应用-编码规则列表API
  plan_qryEncodedRuleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/qryEncodedRuleListPage'
  },
  // 计划创建方式查询
  plan_getPurchaseplan: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getPurchaseplan'
  },
  // 公用应用-编码规则维护API
  plan_dealEncodedRule: {
    // mock: true,
    control: 'dyc/config/cfc/dealEncodedRule'
  },
  // 公用应用-编码规则修改API
  plan_updateEncodedRule: {
    // mock: true,
    control: 'dyc/config/cfc/updateEncodedRule'
  },
  // 采购计划提交api
  plan_submitPurchasePlan: {
    // mock: true,
    control: 'dyc/plan/submitPurchasePlan'
  },
  // 采购计划提交api
  plan_timeReturn: {
    // mock: true,
    control: 'dyc/plan/timeReturn'
  },
  // 采购计划提交api
  plan_timeAndApp: {
    // mock: true,
    control: 'dyc/plan/timeAndApp'
  },
  // 需求计划明细导入
  plan_dealPpcDetailedImportDemandPlan: {
    // mock: true,
    control: 'dyc/plan/dealPpcDetailedImportDemandPlan'
  },
  // 采购计划明细导入
  plan_dealPpcDetailedImportPurchasePlan: {
    // mock: true,
    control: 'dyc/plan/dealPpcDetailedImportPurchasePlan'
  }
};